import {Injectable} from '@angular/core';
import {HttpApiService} from '../common/service/mpvHttpApiService';
import {SigedCommonService} from '../siged-common.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {de} from 'date-fns/locale';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';


export interface AuthProfile {
    codigo: string
    descripcion: string
    id: number
    nombre: string
}

export interface UserSigned {
    apellidos: string
    area: string
    cargo: string
    correo: string
    nombres: string
    id: string
    perfiles: AuthProfile[]
    username: string
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        public httpApiService: HttpApiService,
        public sigedCommonService: SigedCommonService,
        private http: HttpClient,
        private route : Router,
    ) {
    }

    baseUrl = this.sigedCommonService.APPLICATION_API_HOST + '/';

    login(formLogin): any {
        // if (user === 'user' && password === 'password') {
        //     localStorage.setItem('username', user);
        //     return true;
        // }

        return this.httpApiService.postLogin(
            this.baseUrl, 'login', formLogin
        )
    }

    logout(): any {
        localStorage.removeItem('siged-token-cc');
        localStorage.removeItem('siged-token-profile');
        localStorage.removeItem('perfiles');
        localStorage.removeItem('bandeja');

    }

    cerrar(): any {
        this.route.navigate(['/login'])
    }

    getUser(): string {
        return localStorage.getItem('siged-token-cc');
    }

    isLoggedIn(): boolean {
        return this.getUser() !== null;
    }

    /**
     * signed user data
     */
    getProfile(): UserSigned {

        if (localStorage.getItem('siged-token-profile') != null) {
            const {username} = JSON.parse(localStorage.getItem('siged-token-profile'));
            const tokenActive = localStorage.getItem('siged-token-cc');

            //console.log("usuario localstorage :::::",username);

            const decoded = jwtDecode(tokenActive);
            const usuActive = username;
            //console.log("usuario activo::::",usuActive);

            if (usuActive.toUpperCase() != username) {
                return
            } else {
                return JSON.parse(localStorage.getItem('siged-token-profile'));
            }
        } else {
            return
        }
    }

    /**
     * signed user profile selected
     */
    getProfileSelected(): AuthProfile {
        const {perfiles} = this.getProfile();
        console.log('perfiles', perfiles);
        const profileCode = localStorage.getItem('siged-token-profile-selected')

        if (perfiles != null && perfiles != undefined) {
            return perfiles.filter((p) => p.codigo == profileCode).shift();
        }
        return null;

    }

    setPerfilAuditoriaAcceso(
        body: { modulo: string, estado: string },
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {params, headers: {...this.getDefualtHeaders(), ...headers}};
        return this.http.post(`${this.baseUrl}auditoria/acceso`, body, options).toPromise();
    }

    setPerfilAuditoriaAccesoInvalido(
        body: { usuario: string, estado: string },
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {params, headers: {...this.getDefualtHeaders(), ...headers}};
        return this.http.post(`${this.baseUrl}auditoria/accesoInvalido`, body, options).toPromise();
    }

    getProfileName(): string {
        return this.getProfileSelected().nombre
    }

    tokenExpired() {
        try {
            const expiry = (JSON.parse(atob(this.getUser().split('.')[1]))).exp;
            return (Math.floor((new Date).getTime() / 1000)) >= expiry;
        } catch (e) {
            return true;
        }
    }

    getDefualtHeaders() {
        return {
            Authorization: 'Bearer ' + this.getUser()
        }
    }

}


export const AUTH_PROVIDERS: Array<any> = [
    {provide: AuthService, useClass: AuthService}
];
